import { CameraOutlined, DatabaseOutlined, EditOutlined } from "@ant-design/icons";
import { css } from "@linaria/core";
import { Card, Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { clickable } from "../../styles/shared.styles.ts";

const choiceIcon = css`
  font-size: 28px;
  color: var(--ant-color-primary);
`;

export type CreateStep = "label" | "generic" | "manual";

export const CreateIngredientChoiceView = ({ onSelect }: { readonly onSelect: (step: CreateStep) => void }) => {
  const { t } = useTranslation();

  const options: Array<{ step: CreateStep; icon: typeof CameraOutlined; title: string; description: string }> = [
    {
      step: "label",
      icon: CameraOutlined,
      title: t("ingredients.createChoice.fromLabel"),
      description: t("ingredients.createChoice.fromLabelDesc"),
    },
    {
      step: "generic",
      icon: DatabaseOutlined,
      title: t("ingredients.createChoice.fromGeneric"),
      description: t("ingredients.createChoice.fromGenericDesc"),
    },
    {
      step: "manual",
      icon: EditOutlined,
      title: t("ingredients.createChoice.manual"),
      description: t("ingredients.createChoice.manualDesc"),
    },
  ];

  return (
    <Flex gap="middle" vertical>
      {options.map(({ step, icon: Icon, title, description }) => (
        <Card className={clickable} hoverable key={step} onClick={() => onSelect(step)}>
          <Flex align="center" gap="middle">
            <Icon className={choiceIcon} />
            <Flex vertical>
              <Typography.Text strong>{title}</Typography.Text>
              <Typography.Text type="secondary">{description}</Typography.Text>
            </Flex>
          </Flex>
        </Card>
      ))}
    </Flex>
  );
};
